import { createSelector } from 'reselect';
import sortByName from 'library/helpers/sort-by-name';

export const getCategories = (state) => state.categories.data?.sort(sortByName);
export const getCategoriesLoadingState = (state) => state.categories.loading;
export const getUserCategories = (state) => state.userCategories.data?.sort(sortByName);
export const getUserCategoriesLoadingState = (state) => state.userCategories.loading;

export const getCategoriesOptions = createSelector(
  getCategories,
  (items) => items.map(({ name, id }) => ({ value: id, text: name })),
);

export const getUserCategoriesOptions = createSelector(
  getUserCategories,
  (items) => items.map(({ name, id }) => ({ value: id, text: name })),
);
